import * as React from "react";
import { Icon } from "../Icon/icon";

export interface INextProps {
  isEnabled: boolean;
  onClickCallback?(e: React.MouseEvent<HTMLAnchorElement>): void;
  label: string;
}

/**
 * The Next link of a [[ContentPagination]]
 */
export class Next extends React.PureComponent<INextProps> {
  private _nextArrow = (<Icon iconType="fontawesome/chevron-left" />);
  static defaultProps = {
    onClickCallback: () => {},
  };

  constructor(props: INextProps) {
    super(props);
  }

  public render() {
    const { isEnabled, label } = this.props;
    let anchorClassName = "pagination__link pagination__link--next";
    if (!isEnabled) anchorClassName += " pagination__link--disabled";
    let JSX: JSX.Element = null;
    if (isEnabled) {
      JSX = (
        <a
          onClick={this.props.onClickCallback}
          href="#"
          className={anchorClassName}
        >
          <span className="pagination__verbose">{label}</span>
          {this._nextArrow}
        </a>
      );
    } else {
      JSX = (
        <span aria-disabled="true" className={anchorClassName}>
          <span className="pagination__verbose">{label}</span>
          {this._nextArrow}
        </span>
      );
    }
    return JSX;
  }
}
